import { FC } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { get } from 'lodash';
import moment from 'moment';
import Document from 'components/Document';
import { VictimType } from 'typings/globalTypes';
import {
  getExpertInfo,
  getValueFromListings,
  getValueOfOtherPrejudice,
  getValueOfPrejudice,
} from 'containers/ExpertExpertise/ConcernedExpertise/utils';
import { BlobProvider } from '@react-pdf/renderer';
import ExpertiseDocument from 'components/ExpertDocument';
import { Listings } from 'containers/AppContainer/typings';

export interface ExpertRapportDocumentProps {
  intl: IntlShape;
  victim: VictimType;
  expertise: any;
  listings: Listings;
  claimNumber: string;
  lossDate: Date;
  mission: any;
}

const ExpertRapportDocument: FC<ExpertRapportDocumentProps> = (
  props,
): JSX.Element => {
  return (
    <>
      <Document
        name={'Télécharger le rapport'}
        type={'EXPERTISE '}
        icon={
          <BlobProvider
            document={
              (
                <ExpertiseDocument
                  intl={props.intl}
                  data={{
                    lossDate: props.lossDate,
                    claimNumber: props.claimNumber,
                    reference: get(props.mission, 'reference'),
                    expertInfo: {
                      ...getExpertInfo(
                        props.listings,
                        (get(
                          props.expertise,
                          'expertCode',
                        ) as unknown) as string,
                      ),
                    },
                    victimName: `${get(props.victim, 'lastName')} ${get(
                      props.victim,
                      'firstName',
                    )}`,
                    lastName: get(props.victim, 'lastName'),
                    firstName: get(props.victim, 'firstName'),
                    cinVictim: get(props.victim, 'cin'),
                    victimProfession: getValueFromListings(
                      props.listings,
                      'Profession',
                      'ItemKey',
                      get(props.victim, 'professionCode'),
                      'ItemDescription',
                    ),
                    birthDateVictim: moment(
                      get(props.victim, 'dateOfBirth'),
                    ).format('DD/MM/YYYY'),
                    tutorFullName: '', //to-update,
                    certificat: get(props.expertise, 'certificatDescription'),
                    examination: get(props.expertise, 'clinicalExamination'),
                    lesion: get(props.expertise, 'injuryDescription'),
                    itt: get(props.expertise, 'itt'),
                    ipp: get(props.expertise, 'ipp'),
                    pretium: getValueFromListings(
                      props.listings,
                      'pretiumDoloris',
                      'percentage',
                      (get(
                        props.expertise,
                        'pretiumDoloris',
                      ) as unknown) as string,
                      'title',
                    ),
                    otherPrejudice: getValueOfOtherPrejudice(
                      props.listings,
                      props.expertise,
                    ),

                    prejudice: getValueOfPrejudice(
                      props.listings,
                      props.expertise,
                    ),
                  }}
                />
              ) as any
            }
          >
            {params => {
              return (
                <a
                  href={params.url ? params.url : ''}
                  target="_blank"
                  rel="noreferrer"
                >
                  <VisibilityIcon
                    style={{ color: 'black' }}
                    className="consult"
                  />
                </a>
              );
            }}
          </BlobProvider>
        }
      />
    </>
  );
};

export default injectIntl(ExpertRapportDocument);
